import SvgIcon from '@mui/material/SvgIcon'

type UnlockIconProps = {
  fontSize?: string
  color?: string
}

const UnlockIcon: React.FC<UnlockIconProps> = ({ fontSize = '1.5rem', color }) => (
  <SvgIcon viewBox="0 -960 960 960" sx={{ fontSize, color }}>
    <path d="M240-160h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM240-160v-400 400Zm0 80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h280v-80q0-83 58.5-141.5T720-920q71 0 124 43t70 108q5 17-6.5 33T880-720q-17 0-28-7t-16-23q-11-38-42.5-64T720-840q-50 0-85 35t-35 85v80h120q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Z" />
  </SvgIcon>
)

export default UnlockIcon
